import { ArrowButton, SecondaryButton } from '@truphone/buttons'
import { ImageWrap } from '@truphone/gatsby-wrappers'
import SliderCalculator from './SliderCalculator'
import React from 'react'

export default function Calculator(props) {
  return (
    <div className="container mx-auto px-6">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-1/2 px-4 py-10 lg:py-20">
          {props.title && <h2 className="h3-light mb-4">{props.title}</h2>}
          {props.subtitle && <h3 className="h5-muted mb-8">{props.subtitle}</h3>}
          {props.content && (
            <div
              className="text-base mb-8 list-margin list-arrow"
              dangerouslySetInnerHTML={{ __html: props.content }}
            />
          )}
          {props.cta && (
            <ArrowButton href={props.cta.href} className="text-blue-100 lg:text-xl font-medium">
              {props.cta.text}
            </ArrowButton>
          )}
        </div>
        <div className="relative w-full lg:w-1/2 px-4 py-5 lg:py-20">
          {props.backgroundImage && !props.image && (
            <ImageWrap
              className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 max-w-xl"
              {...props.backgroundImage}
              loading="lazy"
            />
          )}
          {props.image ? (
            <ImageWrap className={'relative z-1 rounded-2xl'} {...props.image} loading="lazy" />
          ) : (
            props.form && (
              <div
                className="relative z-1 flex flex-col bg-white px-4 py-6 border-t-4 border-blue-300 shadow-md rounded rounded-b-2xl w-full mx-auto"
                style={{ maxWidth: 482 }}
              >
                <div className="rounded-lg bg-grey-100 p-4 mb-4">
                  <h4 className="font-semibold text-xl mb-4">{props.form.sliderTitle}</h4>
                  <SliderCalculator {...props.form.slider} />
                </div>
                <div className="rounded-lg bg-grey-100 p-4">
                  <h4 className="font-semibold text-xl mb-2">{props.form.formTitle}</h4>
                  <div className="flex flex-wrap -mx-2">
                    {props.form.formItems &&
                      props.form.formItems.map((item, i) => {
                        return (
                          <div key={`form-item-${i}`} className="w-full md:w-1/2 p-2">
                            <p className="text-sm mb-1">{item.label}</p>
                            <input
                              className="w-full rounded-lg border border-grey-200"
                              type={item.type}
                            />
                          </div>
                        )
                      })}
                  </div>
                </div>
                {props.form.cta && (
                  <SecondaryButton className={`mt-4 w-full`} href={props.form.cta.href}>
                    {props.form.cta.text}
                  </SecondaryButton>
                )}
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
}
